import debug from "debug";
import chalk from "chalk";
import dayjs from "dayjs";
import uiStore from "./stores/uiStore";
import utils from "./utils";
import logMessageStore from "./logMessageStore";
import config from "../config";

const APP_PREFIX = 'sc';

class Logger {
    private static count: number = 0;
    debug: (message: string, ...args: any[]) => void;
    trace: (message: string, ...args: any[]) => void;
    event: (message: string, ...args: any[]) => void;
    info: (message: string, ...args: any[]) => void;
    warn: (message: string, ...args: any[]) => void;
    error: (message: string, ...args: any[]) => void;
    throttle: (message: string, ...args: any[]) => void;
    private readonly moduleName: string;
    private defaultColor: string;
    private timestamp: dayjs.Dayjs;

    constructor(moduleName: string) {
        const debug_ = debug(`${APP_PREFIX}:${moduleName}`);
        const trace = debug(`${APP_PREFIX}:TRACE:${moduleName}`);
        const event = debug(`${APP_PREFIX}:EVENT:${moduleName}`);
        const info = debug(`${APP_PREFIX}:INFO:${moduleName}`);
        const warn = debug(`${APP_PREFIX}:WARN:${moduleName}`);
        const error = debug(`${APP_PREFIX}:ERROR:${moduleName}`);
        this.moduleName = moduleName;

        debug_.log = console.info.bind(console);
        trace.log = console.info.bind(console);
        event.log = console.info.bind(console);
        info.log = console.info.bind(console);
        warn.log = console.warn.bind(console);
        error.log = console.error.bind(console);

        const throttled = utils.throttle(() => {
        }, 500);

        this.debug = this.createLogFunction(debug_, "debug");
        this.trace = this.createLogFunction(trace, "trace");
        this.event = this.createLogFunction(event, "event");
        this.info = this.createLogFunction(info, "info", "#c674ff");
        this.warn = this.createLogFunction(warn, "warn", "#ffb700");
        this.error = this.createLogFunction(error, "error", "#ff1515");
        this.throttle = this.createLogFunction(throttled, "throttle");

        const red = Math.round(100 + Math.random() * 100);
        const green = Math.round(175 + (Logger.count * 10 % 30) - Math.random() * 20);
        const blue = Math.round(195 + (Logger.count * 20 % 65) - Math.random() * 5);
        this.defaultColor = `rgb(${red}, ${green}, ${blue})`;

        Logger.count += 1;
    }

    log(message: string, ...args: any[]) {
        for (const arg of args) {
            message = message.replace("%s", arg);
        }
        console.log(chalk.blue(message));
    }

    private _log(message: string, args: any[], logType = "", color = this.defaultColor) {
        if (!uiStore.appManagerEnabled) {
            return;
        }
        if (!this.timestamp) {
            this.timestamp = dayjs();
        }
        const lastTimeStamp = this.timestamp;
        this.timestamp = dayjs();

        for (let arg of args) {
            if (!["string", "number"].includes(typeof arg)) {
                arg = arg && arg.toString ? arg.toString() : JSON.stringify(arg)
            }
            message = message.replace(/%[sdOoj]/, arg);
        }
        const diff = this.timestamp.diff(lastTimeStamp);
        const postFix = "+" + (diff > 1000 ? Math.round(diff / 1000) + "s" : diff + "ms");
        message = logType + (logType && this.moduleName ? ":" : "") + this.moduleName + " " + message + " " + postFix;
        const timeString = this.timestamp.format('H:mm:ss.SSS');
        message = timeString + " " + logType + (logType && this.moduleName ? ":" : "") + this.moduleName + " " + message;
        logMessageStore.upsertMessage({loggerName: this.moduleName, content: message, color});
    }

    private createLogFunction(lambda: (message: string, ...args: any[]) => void, logType: string, color?: string) {
        return (message: string, ...args: any[]) => {
            this._log(message, args, logType, color);
            lambda(message, ...args)
        }
    }
}


try {
    const namespaces = debug.disable();
    //todo: throws error sometimes
    if (["debug", "dev", "test",].includes(config.appEnv) && !namespaces) {
        debug.enable("sc*,-sc:*:List*,-sc:*:ScDrawer*");
        // debug.enable("sc*,-sc:*:List*")
    } else {
        // debug.enable(namespaces)
    }

} catch (e) {
    console.error("Error configuring logging. Error: " + e.message);
}
export default Logger;
